import { useEffect } from 'react';
import qs from 'qs';

export const PostMessageRelatedLogic = () => {
  useEffect(() => {
    const searchObject = qs.parse(window.location.search, {
      ignoreQueryPrefix: true
    });

    if (
      searchObject &&
      searchObject.message &&
      searchObject.mode === 'external' &&
      window.opener
    ) {
      window.opener.postMessage({ status: searchObject.message }, '*');
    }
  }, []);

  return null;
};
